
const firebaseConfig = {
    apiKey: "AIzaSyCd9nIiOZ0ZOInN-b0VfqJVO2vBfQPyE94",
    authDomain: "fenian-tourism.firebaseapp.com",
    projectId: "fenian-tourism",
    storageBucket: "fenian-tourism.appspot.com",
    messagingSenderId: "510026648433",
    appId: "1:510026648433:web:e4f8bb93ce9462640e44d0"
};

export default firebaseConfig;